export const DIRTY_NODES_DECORATE = new WeakMap();
